/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsPlatform
 */
export interface ControlcenterMelcoControlCenterModelsPlatform {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsPlatform
     */
    platform_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsPlatform
     */
    name?: string | null;
}

export function ControlcenterMelcoControlCenterModelsPlatformFromJSON(json: any): ControlcenterMelcoControlCenterModelsPlatform {
    return ControlcenterMelcoControlCenterModelsPlatformFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsPlatform {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'platform_id': !exists(json, 'platform_id') ? undefined : json['platform_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ControlcenterMelcoControlCenterModelsPlatformToJSON(value?: ControlcenterMelcoControlCenterModelsPlatform | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'platform_id': value.platform_id,
        'name': value.name,
    };
}


